import React from 'react';
import BasicLayout from 'layout/Basic';
import getConfig from 'next/config';
import { GetServerSideProps } from 'next';
import { convertProps } from 'lib/parseAPIResponse';
import PremiumPage, { Props } from 'containers/Premium';

export const Premium = (props: Props) => {
    return (
        <BasicLayout ads={props.ads}>
            <PremiumPage {...props} />
        </BasicLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
    const page = query.page || 1;
    const { apiUrl } = getConfig().publicRuntimeConfig;

    return Promise.all([
        fetch(`${apiUrl}/public/api/categories/premium,${page}`),
        fetch(`${apiUrl}/public/api/naszadsik?path=premium`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();
        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
};

export default Premium;
